"use strict";

const wishlist_items = JSON.parse(
  localStorage.getItem("glozin__wishlist-items")
);
const wishlistDiv = document.querySelector(".wishlist-page-main");
var WishlistPageShopify = (function () {
  return {
    initWishlistItems: function () {
      if (window.location.search.indexOf("page=") == -1) {
        this.init();
      }
    },

    init: function () {
      const _this = this;
      if (wishlistDiv) {
        const div_no_product = wishlistDiv.querySelector(
          ".wishlist-no-product-js"
        );
        if (wishlist_items === null || wishlist_items.length === 0) {
          _this.skeletonFunction(0);
          div_no_product.classList.remove("hidden");
        } else {
          var query = "";
          wishlist_items.forEach((e, key, wishlist_items) => {
            if (!Object.is(wishlist_items.length - 1, key)) {
              query += e + "%20OR%20id:";
            } else {
              query += e;
            }
          });
          const section_id = document.querySelector(".wishlist-page-section")
            .dataset.sectionId;
          var productAjaxURL =
            "?section_id=" +
            section_id +
            "&type=product&options[unavailable_products]=last&q=id:" +
            query;

          fetch(`${window.routes.search_url}${productAjaxURL}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = parser.parseFromString(responseText, "text/html");
              const row = document.createElement("div");
              row.classList.add("wishlist-list-items");
              const exist_row = wishlistDiv.querySelector(
                ".wishlist-list-items"
              );
              if (exist_row) {
                exist_row.remove();
              }
              const er = html.querySelector(
                ".wishlist-page-main .wishlist-list-items"
              );
              if (wishlist_items.length !== 0 && er) {
                wishlistDiv.innerHTML = html.querySelector(
                  ".wishlist-page-main"
                ).innerHTML;
                _this.skeletonFunction(700);
              } else {
                _this.skeletonFunction(0);
                div_no_product.classList.remove("hidden");
              }
              _this.mergeItems();
            })
            .catch((e) => {
              console.error(e);
            })
            .finally((e) => {
              initLazyloadItem();
            });
        }
      }
    },
    mergeItems: function () {
      const arr = [];
      if (wishlistDiv) {
        wishlistDiv
          .querySelectorAll("button-wishlist")
          .forEach((e) => {
            if (e?.dataset.productId) {
              arr.push(e.dataset.productId);
            }
          });
      }
      localStorage.setItem("glozin__wishlist-items", JSON.stringify(arr));
    },
    skeletonFunction: function (timer) {
      window.setTimeout(function () {
        if (this.document.querySelector("skeleton-page")) {
          this.document.querySelector("skeleton-page").remove();
        }
        if (this.document.querySelector(".wishlist-page-section-inner")) {
          this.document
            .querySelector(".wishlist-page-section-inner")
            .classList.remove("hidden");
        }
      }, timer);
    },
  };
})();
WishlistPageShopify.initWishlistItems();

// DYNAMIC HANDLERS FOR WISHLIST PRODUCT CARDS ACTIONS
(function() {
  // ADD TO CART
  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('.amr-col-add-btn');
    if (!btn) return;
    const vid = btn.dataset.vid;
    if (!vid) return;
    const orig = btn.innerHTML;
    btn.classList.add('loading');
    btn.innerHTML = '<svg viewBox="0 0 24 24" style="animation:amr-col-spin .8s linear infinite;width:14px;height:14px"><circle cx="12" cy="12" r="9" stroke="#fff" stroke-width="2" fill="none" stroke-dasharray="28" stroke-dashoffset="10"/></svg>';
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({id: vid, quantity: 1})
      });
      if (r.ok) {
        btn.classList.remove('loading'); btn.classList.add('added');
        btn.innerHTML = '<svg viewBox="0 0 24 24" style="width:14px;height:14px"><polyline points="20 6 9 17 4 12" stroke="#fff" stroke-width="2.5" fill="none"/></svg> Added!';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(() => { btn.classList.remove('added'); btn.innerHTML = orig; }, 2200);
      } else { throw new Error(); }
    } catch { btn.classList.remove('loading'); btn.innerHTML = orig; }
  });

  // SHARE
  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('[data-share-url]');
    if (!btn) return;
    const url = window.location.origin + btn.dataset.shareUrl;
    if (navigator.share) { try { await navigator.share({ url }); } catch {} }
    else { try { await navigator.clipboard.writeText(url); } catch {} }
  });

  // QUICK VIEW
  if (!document.getElementById('amr-qv-overlay')) {
    const qvHtml = `
      <div id="amr-qv-overlay" style="display:none;position:fixed;inset:0;background:rgba(20,14,6,0.52);backdrop-filter:blur(5px);z-index:9998;" onclick="document.getElementById('amr-qv-overlay').style.display='none'"></div>
      <div id="amr-qv-modal" style="display:none;position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);z-index:9999;background:#FCFAF7;border-radius:20px;border:1px solid rgba(201,169,110,0.18);box-shadow:0 24px 80px rgba(0,0,0,0.16);width:min(540px,92vw);max-height:88vh;overflow-y:auto;padding:28px;">
        <button onclick="document.getElementById('amr-qv-overlay').style.display='none';document.getElementById('amr-qv-modal').style.display='none'" style="position:absolute;top:14px;right:14px;width:30px;height:30px;border-radius:50%;border:1px solid rgba(201,169,110,0.28);background:transparent;cursor:pointer;display:flex;align-items:center;justify-content:center;">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#3a2e1e" stroke-width="1.8"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
        <div id="amr-qv-content"></div>
      </div>`;
    document.body.insertAdjacentHTML('beforeend', qvHtml);
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-qv-img]');
    if (!btn) return;
    document.getElementById('amr-qv-content').innerHTML = `
      <img src="${btn.dataset.qvImg}" style="width:100%;aspect-ratio:1;object-fit:contain;border-radius:12px;margin-bottom:18px;padding:10px;background:rgba(252,250,247,0.6);">
      <span style="font-size:9px;font-weight:700;letter-spacing:0.22em;text-transform:uppercase;color:#C9A96E;display:block;margin-bottom:7px;">${btn.dataset.qvType || ''}</span>
      <h3 style="font-size:19px;font-weight:300;color:#1a1a1a;margin:0 0 10px;">${btn.dataset.qvTitle}</h3>
      <p style="font-size:17px;font-weight:700;color:#C9A96E;margin-bottom:18px;">${btn.dataset.qvPrice}</p>
      <a href="${btn.dataset.qvUrl}" style="font-size:10px;font-weight:700;letter-spacing:0.16em;text-transform:uppercase;color:#C9A96E;text-decoration:none;border-bottom:1px solid rgba(201,169,110,0.38);">View Full Details →</a>`;
    document.getElementById('amr-qv-overlay').style.display = 'block';
    document.getElementById('amr-qv-modal').style.display = 'block';
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (document.getElementById('amr-qv-overlay')) {
        document.getElementById('amr-qv-overlay').style.display = 'none';
        document.getElementById('amr-qv-modal').style.display = 'none';
      }
    }
  });
})();
